<template>
  <!-- 实训中心-关联用户界面 -->
  <div class="associated-users">
    <div class="users-header">
      <span class="users-header-title" @click="onAddUsers">添加用户 <i class="el-icon-circle-plus-outline"></i></span>
      <div class="users-header-right">
        <span @click="batchRemove()"><i class="icon-delete"></i>批量删除</span>
        <search-box :placeholderName="'请输入姓名、账号或联系方式'" :buttonShow="true" @onSearchKey="onSearchUsers"></search-box>
      </div>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{background:'#E7F1FF',color:'#606266'}"
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      stripe
      border>
      <el-table-column type="selection" align="center" width="55"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
      <el-table-column prop="loginName" label="账号" align="center"></el-table-column>
      <el-table-column prop="realName" label="名字" align="center"></el-table-column>
      <el-table-column prop="tenantType" label="性别" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sex == 10 ? '男' : '女' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="联系方式" align="center"></el-table-column>
      <el-table-column prop="orgName" label="所属组织" align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="batchRemove(scope.row.id)" type="text" size="small">
            移除
          </el-button>
        </template>
      </el-table-column>
      <!-- ele 暂无数据插槽 -->
      <template slot="empty">
        <div class="noData">当前无用户数据，开始添加吧~</div>
      </template>
    </el-table>

    <div class="popup-list">
      <!-- 添加用户 -->
      <gat-popup
        :class="['popup-addUsers', popupActive === 'addUsers' ? 'on' : 'off']"
        :title="'添加用户'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="addUsersProject"
      >
        <template v-slot:content>
          <div class="popup-addUsers-centent">
            <div class="centent-left">
              <div class="search-users popup-border-color">
                <el-input
                  placeholder="请输入用户姓名"
                  v-model.trim="searchAddUsersName"
                  @keyup.enter.native="onSearchAddUsers"
                >
                  <i slot="suffix" class="icon-search-box" @click="onSearchAddUsers">
                    <span class="el-icon-search"></span>
                  </i>
                </el-input>
              </div>
              <div class="users-list popup-border-color">
                <el-tree
                  :data="usersList"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="defaultProps"
                  @check-change="handleCheckChange">
                </el-tree>
              </div>
            </div>
            <div class="centent-right popup-border-color">
              <div class="centent-right-header">
                <span>{{selectList&&selectList.length!==0 ? `已选择${selectList.length}个用户`:'请选择需要添加的用户'}}</span>
                <span @click="onDeselectAllUsers">全部清除</span>
              </div>
              <div class="users-list">
                <ul>
                  <li class="users-list-li" v-for="(item, index) in selectList" :key="index">
                    <span>{{item.realName}}</span>
                    <i class="el-icon-close" @click="onDeselectUsers(item)"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 移除 -->
      <gat-popup
        :class="['popup-delete popup-remove', popupActive === 'remove' ? 'on' : 'off']"
        :title="''"
        :primary-button="'移除'"
        @cancel="cancelPopup"
        @confirm="removeProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">{{popupRemoveText.title}}</span>
            </div>

            <div class="content">{{popupRemoveText.content}}</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'

import SearchBox from '@/components/common/SearchBox.vue'
import GatPopup from '@/components/common/GatPopup'
import ElTree from '@/assets/tree/src/tree.vue'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'

export default {
  name: 'associatedUsers',
  components: {SearchBox, GatPopup, ElTree, IconInfoHelp},
  props: {
    curriculumId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      defaultProps: {
        children: 'userList',
        label: 'name'
      },
      tableData: [],
      popupActive: '',
      usersList: [], // 关联用户弹窗-左侧组织用户列表
      selectList: [], // 关联用户弹窗-选中用户列表
      searchUsersName: '', // 表格关联用户-搜索
      searchAddUsersName: '', // 关联用户弹窗-搜索
      searchUserState: '', // 关联用户弹窗-搜索用户状态
      userId: '', // 删除已关联课程的用户（单）
      selectUserIdList: [], // 删除已关联课程的用户（批）
      popupRemoveText: {
        title: '确定移除用户吗？',
        content: '移除用户将删除该用户在本课程所有学习记录，且不可恢复！',
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
    }
  },
  watch: {},
  created() {
    this.getUserListByCurriculumId()
  },
  methods: {
    // 搜索
    onSearchUsers(key) {
      this.searchUsersName = key
      // 查询组织列表
      this.getUserListByCurriculumId()
    },
    // 根据课程id查询租户关联信息
    getUserListByCurriculumId() {
      let data = {
        curriculumId: this.curriculumId,
        keyword: this.searchUsersName,
      }
      return PROJECTS.getUserListByCurriculumId(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.tableData = res.data || []
          this.$emit('getTableData', this.tableData)
        } else {
          this.tableData = []
        }
      }).catch((err) => {
        console.log(err)
        this.tableData = []
      })
    },

    // 关联用户弹窗
    onAddUsers() {
      this.popupActive = 'addUsers'
      this.selectList = JSON.parse(JSON.stringify(this.tableData))

      // 获取组织列表
      this.getStudentByCurrentUser()
    },
    // 关联用户搜索
    onSearchAddUsers() {
      if (this.searchUserState !== this.searchAddUsersName) {
        this.searchUserState = this.searchAddUsersName
        this.getStudentByCurrentUser()
      }
    },

    // 获取组织、用户列表
    getStudentByCurrentUser() {
      let data = {
        curriculumId: this.curriculumId,
        keyword: this.searchAddUsersName,
      }
      return PROJECTS.getStudentByCurrentUser(data).then((res) => {
        // console.log('查询组织列表', res.data)
        if (res && res.returnCode == 200) {
          this.usersList = res.data
          this.usersList.forEach(item => {
            if (item.userList) {
              item.userList.forEach(element => {
                element.id = element.userId,
                element.name = element.realName
              })
            } else {
              item.id = item.userId,
              item.name = item.realName
            }
          });

          this.$nextTick(()=>{
            if(this.selectList && this.selectList.length){
              this.selectList.forEach(item => {
                // item.id = item.userId,
                item.name = item.realName
                this.myFilter(item.id)
              });
            }
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    //因为这里初始默认选中的数据结构和 组织列表的数据结构不一致,所以进行了多一层处理
	  //将初始默认选中的数据传入进行过滤,将过滤成功的数据进行勾选并渲染
    myFilter(value) {
      let _this = this
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach((child) => {
          if(child.data.id === value){
            _this.$refs.tree.setMyChecked(child.data, true, true);
          }
          traverse(child);
        });
      };
      traverse(this.$refs.tree);
    },

    // 选中用户触发
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked);
      //设置选择框状态
      data.id &&
        this.$refs.tree.setMyChecked &&
        this.$refs.tree.setMyChecked(data, checked, true);

      //右边渲染列表
      if (this.searchUserState) { // 搜索状态下
        if (checked) { // 勾选用户
          let selectUser = this.selectList.filter(item => {
            return item.id === data.id
          });
          // console.log('selectUser', selectUser)
          if (selectUser.length === 0) {
            this.selectList.push(data)
          }
        } else { // 取消勾选用户
          this.selectList = this.selectList.filter(item => {
            return item.id !== data.id
          });
        }
      } else { // 未搜索查所有
        let workDeptIds = this.$refs.tree.getCheckedNodes()
          .filter(item => { // 过滤掉组织
            return item.userId
          });
        this.selectList = this.unique(workDeptIds);
      }
    },
    //去重
    unique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].id == arr[j].id) {
            //第一个等同于第二个，splice方法删除第二个
            arr.splice(j, 1)
            j--
          }
        }
      }
      return arr
    },

    // 确认添加用户-保存课程与用户的关联关系
    addUsersProject() {
      let data = {
        curriculumId: this.curriculumId,
        userIds: []
      }
      this.selectList.forEach(item => {
        data.userIds.push(item.id)
      });

      PROJECTS.saveCurriculumAndStudent(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.$message.success('关联成功!')
          // 查询组织列表
          this.getUserListByCurriculumId()
          this.cancelPopup()
        } else {
          this.$message.error(res.returnMsg)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    
    // 删除弹窗选中用户
    onDeselectUsers(data) {
      this.selectList = this.selectList.filter(item => {
        return item.id !== data.id
      });
      this.$refs.tree.setMyChecked &&
        this.$refs.tree.setMyChecked(data, false, true);
    },
    // 删除弹窗所有选中用户
    onDeselectAllUsers() {
      this.selectList = []
      this.$refs.tree.setCheckedKeys([]);
    },

    // 选中关联的用户
    handleSelectionChange(val) {
      this.selectUserIdList = val
    },
    // 单删、批删
    batchRemove(rowUserId) {
      if (rowUserId) { // 单删
        this.rowUserId = rowUserId || ''
        this.popupRemoveText.content = '移除用户将删除该用户在本课程所有学习记录，且不可恢复！'
        this.popupActive = 'remove'
      } else { // 批删
        if (this.selectUserIdList.length !== 0) {
          this.popupRemoveText.content = '移除用户将删除其在本课程所有学习记录，且不可恢复！'
          this.popupActive = 'remove'
        } else {
          this.$message.warning('请勾选需要移除的用户!')
        }
      }
    },
    // 确认移除关联的用户
    removeProject() {
      if (this.rowUserId) {
        this.removeUser() // 移除关联用户
      } else {
        this.batchRemoveUsers() // 批量删除关联用户
      }
    },
    removeUserReturn(res) {
      if (res && res.returnCode == 200) {
        this.$message.success('移除成功!')
        this.getUserListByCurriculumId()
        this.cancelPopup()
      } else {
        this.$message.error(res.returnMsg)
      }
    },
    // 移除关联用户
    removeUser() {
      let data = {
        curriculumId: this.curriculumId,
        userId: this.rowUserId
      }
      PROJECTS.deleteCurriculumUser(data).then((res) => {
        this.removeUserReturn(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 批量删除关联用户
    batchRemoveUsers() {
      let data = {
        curriculumId: this.curriculumId,
        userIds: []
      }
      this.selectUserIdList.forEach(item => {
        data.userIds.push(item.id)
      });
      PROJECTS.batchDeleteCurriculumUser(data).then((res) => {
        this.removeUserReturn(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    
    // 取消弹窗
    cancelPopup() {
      this.rowUserId = '';
      // this.selectUserIdList = [];
      this.searchAddUsersName = '';
      this.selectList = [];
      this.$emit("handleCancel", false);
      this.$refs.tree.setCheckedKeys([]);
      this.searchUserState = ''; // 清空搜索字段

      this.popupActive = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.associated-users {
  width: 100%;
  height: 100%;

  .users-header {
    height: 80px;
    background-color: #fff;
    border: 1px solid #e7edf8;
    box-shadow: 0px 4px 10px 0px rgba(109, 113, 171, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    margin-bottom: 20px;
    .users-header-title {
      font-size: 14px;
      background-color: #4c88ff;
      border-radius: 5px;
      padding: 10px 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 20px;
        margin-left: 10px;
      }
    }
    .users-header-right {
      display: flex;
      align-items: center;
      span {
        width: 117px;
        height: 36px;
        color: #4C88FF;
        font-size: 16px;
        border: 1px solid #4C88FF;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
        cursor: pointer;
        .icon-delete {
          width: 16px;
          height: 16px;
          // background: url("../../../assets/images/trainingCenter/icon_delete.png") no-repeat center;
          background: url("~@/assets/images/trainingCenter/icon_delete.png") no-repeat center;
          background-size: 100% 100%;
          margin: 0 5px 4px 0;
        }
      }
    }
  }
  .el-table {
    border: 1px solid #e7edf8;
    box-shadow: 0px 4px 10px 0px rgba(109, 113, 171, 0.1);
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: rgba(231, 241, 255, 0.7);
  }

  .popup-list {
    .popup {
      z-index: 3;
    }
    .popup-addUsers,
    .popup-delete {
      &.off {
        display: none;
      }
    }
    .popup-addUsers {
      z-index: 9;
      &::v-deep .popup-inner {
        width: 934px;
        height: 500px;
        .popup-buttons {
          position: static;
          text-align: right;
          margin-right: 120px;
        }
      }
      &::v-deep .popup-head {
        color: #2B6CEB;
        font-weight: 700;
      }
      .popup-addUsers-centent {
        padding: 32px 20px;
        display: flex;
        justify-content: space-between;
        .popup-border-color {
          border: 1px solid #85B6FF;
          box-shadow: 0px 2px 8px 0px rgba(59, 135, 249, 0.1);
        }
        .centent-left {
          width: 400px;
          .search-users {
            height: 36px;
            margin-bottom: 2px;
            box-sizing: border-box;
            overflow: hidden;
            /deep/.el-input {
              margin-top: 0;
              height: 36px;
            }
            /deep/.el-input__inner {
              width: 100%;
              height: 100%;
              border: none;
            }
            .icon-search-box {
              font-size: 20px;
              // vertical-align: -15px;
              line-height: 36px;
              padding-right: 5px;
              cursor: pointer;
            }
          }
          /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
          /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #3B87F9;
            border-color: #3B87F9;
          }
          /deep/.el-tree-node__content {
            height: 28px;
            .el-checkbox__inner {
              width: 18px;
              height: 18px;
              border-radius: 50%;
              &::after {
                width: 4px;
                height: 9px;
                top: 1.5px;
                left: 6px;
              }
            }
            .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
              top: 7px;
            }
            .el-tree-node__label {
              color: #6c7682;
              font-size: 16px;
            }
          }
        }

        .centent-right {
          width: 400px;
          // height: 314px;
          height: 334px;
          font-size: 14px;
          .centent-right-header {
            height: 38px;
            border: 1px solid #D8E5FD;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 17px;
            span:first-child {
              color: #333333;
              font-weight: 700;
            }
            span:last-child {
              color: #fff;
              width: 73px;
              height: 26px;
              background: #4C88FF;
              border-radius: 3px;
              line-height: 26px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
        .users-list {
          height: 276px;
          padding: 10px 0px;
          overflow-x: hidden;
          overflow-y: auto;
          ul {
            li {
              // height: 30px;
              font-size: 16px;
              display: flex;
              align-items: center;
              padding: 5px 20px;
              i {
                width: 18px;
                height: 18px;
                // margin-right: 10px;
                box-sizing: border-box;
                cursor: pointer;
              }
              .icon-circular {
                border: 1px solid #BBBFD0;
                border-radius: 50%;
              }
              .el-icon-success {
                color: #3B87F9;
                font-size: 20px;
              }
              span {
                flex: 1;
              }
              &:hover {
                background: #EEF4FC;
              }
            }
            .users-list-li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .el-icon-close {
                color: #3B87F9;
                font-size: 20px;
                font-weight: 700;
              }
            }
          }
          /*修改滚动条样式*/
          &::-webkit-scrollbar{
            width: 6px;
            height: 10px;
          }
          &::-webkit-scrollbar-track{
            // background: rgb(239, 239, 239);
            background: #EEF4FC;
            border-radius: 2px;
          }
          &::-webkit-scrollbar-thumb{
            background: #3B87F9;
            border-radius:10px;
          }
          &::-webkit-scrollbar-thumb:hover{
            background: #3B87F9;
          }
          &::-webkit-scrollbar-corner{
            background: #179a16;
          }
        }
      }
    }
    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
          margin-top: 25px;
        }
      }
      /deep/.popup-inner .popup-content {
        padding: 0 20px;
      }
    }
    .pop-select {
      width: 100%;
    }
    .pop-el-form {
      margin-top: 30px;
    }
  }
}
</style>